import { FormBoolean } from "components/ui/forms/form-boolean";
import { FormCurrency } from "components/ui/forms/form-currency";
import { FormDropdown } from "components/ui/forms/form-dropdown";
import { FormInput } from "components/ui/forms/form-input";
import { useWatch } from "react-hook-form";
import { PropertySecurityUnitTemplate } from "./property-security-unit-template";
import { Fragment } from "react/jsx-runtime";
import { PropertyFieldSection } from "../../property-field-section";
import { getKeyOfProperty } from "../../../utils/get-key-of-property";
import { PropertySectionKind } from "../../../types/property-section.view-model";

export const propertyTypeOptions = ["Residential", "Commercial", "Land"];

export const propertySubTypeOptions = [
  "Flat",
  "Terrace",
  "Semi-detached",
  "Detached",
  "Bungalow",
  "Office",
  "Industrial",
  "Retail",
  "Distribution",
  "Health care",
  "Hotel",
  "Land / Hardstand",
  "Other",
];

type PropertySecurityTemplateProps = {
  title: string;
  kind: PropertySectionKind;
  securityNumber: number;
};

export function PropertySecurityTemplate({
  title,
  kind,
  securityNumber,
}: PropertySecurityTemplateProps) {
  const numberOfUnits = useWatch({ name: getKeyOfProperty("number_of_units", securityNumber) });

  return (
    <>
      <PropertyFieldSection title={title} kind={kind}>
        <FormInput
          type="text"
          name={getKeyOfProperty("postcode", securityNumber)}
          label="Postcode"
        />

        <FormInput
          type="text"
          name={getKeyOfProperty("title_number", securityNumber)}
          label="Title Number"
        />

        <FormDropdown
          name={getKeyOfProperty("property_type", securityNumber)}
          label="Property Type"
          options={propertyTypeOptions}
        />

        <FormDropdown
          name={getKeyOfProperty("sub_type", securityNumber)}
          label="Property Sub-Type"
          options={propertySubTypeOptions}
        />

        <FormBoolean name={getKeyOfProperty("development", securityNumber)} label="Development" />

        <FormBoolean
          name={getKeyOfProperty("development_complete", securityNumber)}
          label="Is Development Complete?"
        />

        <FormInput
          type="date"
          name={getKeyOfProperty("completion_date", securityNumber)}
          label="Anticipated Practical Completion Date"
        />
        <FormCurrency
          name={getKeyOfProperty("purchase_price", securityNumber)}
          label="Purchase Price"
        />

        <FormCurrency
          name={getKeyOfProperty("recent_valuation", securityNumber)}
          label="Most Recent Valuation"
        />

        <FormCurrency name={getKeyOfProperty("gdv", securityNumber)} label="GDV (if applicable)" />

        <FormCurrency
          name={getKeyOfProperty("draws_to_date", securityNumber)}
          label="Draws to Date"
        />

        <FormCurrency
          name={getKeyOfProperty("remaining_to_draw", securityNumber)}
          label="Remaining to Draw"
        />

        <FormInput
          type="date"
          name={getKeyOfProperty("insurance_expiry", securityNumber)}
          label="Insurance Expiry Date"
        />

        <FormInput
          type="number"
          name={getKeyOfProperty("square_feet", securityNumber)}
          label="Square Feet"
        />

        <FormInput
          type="number"
          name={getKeyOfProperty("number_of_units", securityNumber)}
          label="Number of Units"
        />
      </PropertyFieldSection>

      {numberOfUnits > 0 &&
        Array.from({ length: numberOfUnits }).map((_, unitIndex) => (
          <Fragment key={unitIndex}>
            <PropertySecurityUnitTemplate
              unitNumber={unitIndex + 1}
              securityNumber={securityNumber}
            />
          </Fragment>
        ))}
    </>
  );
}
